import {
  getAppUrl,
  getAppNameWithVersion,
} from '@wix/wix-data-client-common-standalone'
import type {
  ErrorMonitor,
  ErrorMonitorOptions,
} from '@wix/error-monitor' // TODO:TS: fix this
import { APP_NAME } from '../../helpers/constants'
import type { Platform } from '../contract'

export const createErrorMonitor = ({
  monitor,
  dsn,
  platform,
}: {
  monitor:{ createErrorMonitor: (options: ErrorMonitorOptions) => ErrorMonitor }
  dsn: string
  platform: Platform
}): ErrorMonitor => {
  const appUrl = getAppUrl(APP_NAME)
  const version = getAppNameWithVersion(appUrl)

  const errorMonitor = monitor.createErrorMonitor({
    dsn,
    appName: APP_NAME,
    version,
    environment: platform.settings.mode.name,
    user: { id: platform.user.id },
  })

  return errorMonitor
}
